function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { isDesktop } from "react-device-detect";
import styled from "styled-components";
import Button from "../../components/Button/Button";
import Text from "../../components/Text/Text";
import MoreHorizontal from "../../components/Svg/Icons/MoreHorizontal";
import { connectorLocalStorageKey, walletConnectConfig, walletLocalStorageKey } from "./config";
var WalletButton = styled(Button).attrs({
    className: "wallet-choice",
    width: "100%",
    variant: "text",
    py: "16px"
}).withConfig({
    componentId: "sc-6ee90262-0"
})(_templateObject());
var MoreWalletCard = function(_param) {
    var t = _param.t, props = _objectWithoutProperties(_param, [
        "t"
    ]);
    return /*#__PURE__*/ _jsxs(WalletButton, _objectSpread({
        variant: "tertiary"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx(MoreHorizontal, {
                width: "40px",
                mb: "8px",
                color: "textSubtle"
            }),
            /*#__PURE__*/ _jsx(Text, {
                fontSize: "14px",
                children: t("More")
            })
        ]
    }));
};
export { MoreWalletCard };
var WalletCard = function(param) {
    var login = param.login, walletConfig = param.walletConfig, onDismiss = param.onDismiss;
    var title = walletConfig.title, Icon = walletConfig.icon;
    return /*#__PURE__*/ _jsxs(WalletButton, {
        variant: "tertiary",
        onClick: function() {
            // TW point to WC on desktop
            if (title === "Trust Wallet" && walletConnectConfig && isDesktop) {
                login(walletConnectConfig.connectorId);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(walletLocalStorageKey, walletConnectConfig.title);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(connectorLocalStorageKey, walletConnectConfig.connectorId);
                onDismiss();
                return;
            }
            if (!window.ethereum && walletConfig.href) {
                window.open(walletConfig.href, "_blank", "noopener noreferrer");
            } else {
                login(walletConfig.connectorId);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(walletLocalStorageKey, walletConfig.title);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(connectorLocalStorageKey, walletConfig.connectorId);
                onDismiss();
            }
        },
        id: "wallet-connect-".concat(title.toLocaleLowerCase()),
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                width: "40px",
                mb: "8px"
            }),
            /*#__PURE__*/ _jsx(Text, {
                fontSize: "14px",
                children: title
            })
        ]
    });
};
export default WalletCard;
